import { formatDistanceStrict } from 'date-fns';
import { useEffect, useState } from 'react';

const MINUTE = 60_000;

/**
 * How long an invitation has left, kept current. A notification stays in the list long after it
 * arrives, so the time left is counted from the expiry rather than written into its text.
 */
export const useInviteExpiry = (expiresAt?: string) => {
  const [now, setNow] = useState(() => Date.now());
  const expiry = expiresAt ? Date.parse(expiresAt) : Number.NaN;
  const known = !Number.isNaN(expiry);
  const live = known && now < expiry;

  useEffect(() => {
    if (!live) return;
    const timer = window.setInterval(() => setNow(Date.now()), MINUTE);
    return () => window.clearInterval(timer);
  }, [live]);

  if (!known) return { expired: false, label: undefined };
  if (!live) return { expired: true, label: 'This invitation has expired.' };
  return {
    expired: false,
    label: `This invitation expires in ${formatDistanceStrict(expiry, now)}.`,
  };
};
